import React from 'react';

import { observer } from 'mobx-react';

import { useStore } from 'utils/hooks/store';

import { findUnit, shortUnitName, unitPath } from 'containers/OrganisationStructure/types';

import { NoUnit, UnitValueRow, HeaderUnitText } from './styles';

const SiteUnitValue: React.FunctionComponent<{ unitUuid: string | null }> = ({ unitUuid }) => {
  const { organisationStructure } = useStore();

  React.useEffect(() => {
    organisationStructure.loadUnits(false);
  }, [organisationStructure]);

  const units = organisationStructure.tree;
  const unitId = unitUuid && findUnit(units, unitUuid) ? unitUuid : null;

  return (
    <UnitValueRow>
      {unitId ? (
        <HeaderUnitText title={unitPath(units, unitId)}>{shortUnitName(units, unitId)}</HeaderUnitText>
      ) : (
        <NoUnit>No unit</NoUnit>
      )}
    </UnitValueRow>
  );
};

export default observer(SiteUnitValue);
